<template>
  <el-card class="collapsible-card" :body-style="collapsed ? { display: 'none' } : {}" shadow="never">
    <template #header>
      <div
        class="cc-header"
        role="button"
        tabindex="0"
        :aria-expanded="String(!collapsed)"
        @click="toggle"
        @keydown.enter.prevent="toggle"
        @keydown.space.prevent="toggle"
      >
        <span class="cc-title">{{ title }}</span>
        <span v-if="hint" class="cc-hint">{{ hint }}</span>
        <span class="cc-actions" @click.stop><slot name="actions" /></span>
        <el-icon class="cc-chevron" :class="{ collapsed }"><ArrowDown /></el-icon>
      </div>
    </template>
    <slot />
  </el-card>
</template>

<script setup>
import { ref, defineProps, defineExpose } from 'vue';
import { ArrowDown } from '@element-plus/icons-vue';

defineProps({
  title: { type: String, required: true },
  hint: { type: String, default: '' },
});

const collapsed = ref(false);
const toggle = () => { collapsed.value = !collapsed.value; };
const expand = () => { collapsed.value = false; };
defineExpose({ expand });
</script>

<style scoped>
.collapsible-card { border-radius: 6px; }
.collapsible-card :deep(.el-card__header) { padding: 12px 16px; }
.cc-header { display: flex; align-items: center; gap: 10px; cursor: pointer; user-select: none; }
.cc-header:focus-visible { outline: 2px solid var(--el-color-primary); outline-offset: -2px; }
.cc-title { font-size: 14.5px; font-weight: 600; }
.cc-hint { font-size: 12px; color: var(--el-text-color-secondary); }
.cc-actions { margin-left: auto; display: flex; align-items: center; gap: 6px; }
.cc-chevron { color: var(--el-text-color-secondary); transition: transform 0.15s ease; }
.cc-chevron.collapsed { transform: rotate(-90deg); }
@media (prefers-reduced-motion: reduce) { .cc-chevron { transition: none; } }
</style>
